// extracted by mini-css-extract-plugin
export var wrapper = "embed-video-module--wrapper--ILIWL";
export var iframe = "embed-video-module--iframe---V7rO";